module.exports = __webpack_public_path__ + "img/douyinminigame.d678f33c.png";